import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';
import { resolveListingCondition } from '../../util/listingCondition';
import { getCategoryLabel, getSubcategoryLabel } from '../../util/storeTaxonomy';

import css from './ListingPage.module.css';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingConfig, intl, listing } = props;
  const { listingFields } = listingConfig || {};

  if (!publicData || !listingConfig) {
    return null;
  }

  // Obtener nombre del autor (OWNER)
  let authorName = '';
  if (listing && listing.author && listing.author.attributes && listing.author.attributes.profile) {
    authorName = listing.author.attributes.profile.displayName;
  } else if (publicData.owner) {
    authorName = publicData.owner;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, includeForListingTypes, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType =
      includeForListingTypes == null || includeForListingTypes.includes(listingType);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = publicDataValue || metadataValue;

    if (isDetail && isTargetListingType && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFields.reduce(pickListingFields, []);

  const condition = resolveListingCondition(publicData) || '';
  const subcategory = getSubcategoryLabel(publicData?.subcategory);
  const category = getCategoryLabel(publicData?.category);
  const associate = publicData?.associate || '';

  // Build the dynamic title
  let dynamicTitle = '';
  if (condition || subcategory || category) {
    dynamicTitle += [condition, subcategory, category].filter(Boolean).join(' ');
  }
  if (authorName) {
    dynamicTitle += (dynamicTitle ? ' sold by ' : 'Sold by ') + authorName;
  }
  if (associate) {
    dynamicTitle += (authorName ? ' from ' : 'From ') + associate;
  }

  return existingListingFields.length > 0 ? (
    <div className={css.sectionDetails}>
      {dynamicTitle && <div className={css.detailsHighlightTitle}>{dynamicTitle}</div>}
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {existingListingFields.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>{detail.label}</span>
            <span>{detail.value}</span>
          </li>
        ))}
        {publicData && publicData.isHandcrafted && (
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>
              {<FormattedMessage id="ListingPage.isHandcrafted" />}
            </span>
            <span>
              {publicData.isHandcrafted === true || publicData.isHandcrafted === 'true'
                ? 'Yes'
                : 'No'}
            </span>
          </li>
        )}
      </ul>
    </div>
  ) : null;
};

export default SectionDetailsMaybe;
